import { useState } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import { changeAccountPlan as ChangeAccountPlanData } from './types/changeAccountPlan';
import { useZapsToBePaused } from '@zapier/design-system-revenue/src/hooks';

export const CHANGE_PLAN = gql`
  mutation changeAccountPlan(
    $accountId: Int!
    $inputData: ChangeAccountPlanInput!
  ) {
    changeAccountPlan(id: $accountId, input: $inputData) {
      id
      currentPlan: planV2 {
        id
      }
    }
  }
`;

type Input = {
  accountId: number | undefined;
  planId: string | number | undefined;
  downgradeReason: string | null | undefined;
};

export const useChangePlan = ({
  accountId,
  planId,
  downgradeReason,
}: Input) => {
  const [isChangingPlan, setIsChangingPlan] = useState(false);
  const [hasChangedPlan, setHasChangedPlan] = useState(false);
  const [changePlanError, setChangePlanError] = useState('');

  const inputData = {
    planId,
    downgradeReason,
  };

  const [changePlanMutation] = useMutation<ChangeAccountPlanData>(CHANGE_PLAN, {
    variables: {
      accountId,
      inputData,
    },
  });

  const { zaps, isLoading: isLoadingZaps } = useZapsToBePaused({
    accountId,
    planId,
  });

  const changePlan = async () => {
    setChangePlanError('');
    setIsChangingPlan(true);
    try {
      await changePlanMutation();
      setHasChangedPlan(true);
    } catch (e) {
      setChangePlanError(e.message.replace('GraphQL error: ', ''));
    } finally {
      setIsChangingPlan(false);
    }
  };

  return {
    changePlan,
    changePlanError,
    hasChangedPlan: hasChangedPlan && !isLoadingZaps,
    isChangingPlan: isChangingPlan || isLoadingZaps,
    pausedZaps: zaps,
  };
};
